import { Base64 } from '@js-sdk/encoding';
import { Errors } from '../enums/errors';
import { FileError } from '../error/file';
import { KeySystemSetting } from './eme/keysystem_setting';
export const UNPROTECTED_AUDIO_CODEC = 'audio/mpeg; codecs="mp3"';
export const PROTECTED_AUDIO_CODEC = 'audio/mp4; codecs="mp4a.40.2"';
export class Content {
    constructor(options) {
        this._duration = 0;
        this._fallbackURLs = [];
        this._fragments = [];
        this._loaded = false;
        this._mediaType = 'audio';
        this._resolvedURLs = [];
        this._segmentLength = 0;
        this._abrManager = options.abrManager;
        this._audioCodec = options.audioCodec || PROTECTED_AUDIO_CODEC;
        this._audioMimeType = options.audioMimeType;
        this._disableCache = options.disableCache;
        this._fileId = options.fileId;
        this._format = options.format;
        this._isAd = options.isAd || false;
        this._keySystem = options.keySystem;
        this._keySystemSettings = KeySystemSetting[this._keySystem];
        this._licenseEndpoint = options.licenseEndpoint;
        // TODO: Fix logData for video_content
        this._logData = options.logData || { displayTrack: '', playbackId: '' };
        this._resolver = options.resolver;
        this._resolvedURL = options.resolvedURL;
        this._transport = options.transport;
        this._uri = options.uri;
    }
    /**
     * Parses a base64 encoded PSSH box and converts it into a Uint8Array.
     *
     * @param psshBox - A base64 encoded PSSH Box.
     * @return The decoded PSSH Box.
     */
    _parsePSSHBox(psshBox) {
        const decoded = Base64.decode(psshBox);
        const box = new Uint8Array(decoded.length);
        for (let i = 0, l = decoded.length; i < l; i++) {
            box[i] = decoded.charCodeAt(i);
        }
        return box;
    }
    _parseAssetID(assetId) {
        const decoded = Base64.decode(assetId);
        const parts = new Array(decoded.length);
        for (let i = 0, l = decoded.length; i < l; i++) {
            const hexVal = decoded.charCodeAt(i).toString(16);
            parts[i] = hexVal.length === 1 ? `0${hexVal}` : hexVal;
        }
        return parts.join('');
    }
    getCalculatedDuration() {
        return this._duration;
    }
    getFileId() {
        return this._fileId;
    }
    getFormat() {
        return this._format || '';
    }
    /**
     * Returns the length of content fragment.
     *
     * @return The average length of content fragment.
     */
    getFragmentLength() {
        return this._segmentLength;
    }
    /**
     * Returns the "init fragment" for the track.
     *
     * @return  The init fragment.
     */
    getInitFragment() {
        return this._initFragment;
    }
    getInitParams() {
        const initData = {
            keySystem: this._keySystem,
            initDataType: this._protection,
            initData: this._psshBox,
            licenseServer: null,
        };
        return Promise.resolve(initData);
    }
    /**
     * Returns the keysystem for the Content.
     *
     * @return The keysystem.
     */
    getKeySystem() {
        return this._keySystem;
    }
    /**
     * Returns the optional property value for the license server url.
     *
     * @return The endpoint url if it's set.
     */
    getLicenseEndpoint() {
        return this._licenseEndpoint;
    }
    getLogData() {
        return this._logData || {};
    }
    /**
     * Returns the MediaType for the Content.
     *
     * @return The MediaType.
     */
    getMediaType() {
        return this._mediaType;
    }
    getResolvedURL() {
        return this._resolvedURL;
    }
    getResolvedURLs() {
        return this._resolvedURLs;
    }
    getHLSURL() {
        throw new FileError(Errors.FILE_NOT_RESOLVED, 'Cannot return HLS Manifest URL: File not resolved.');
    }
    getURI() {
        return this._uri;
    }
    /**
     * Returns whether the track is an ad.
     *
     * @return True if the track is an ad.
     */
    isAd() {
        return this._isAd;
    }
    /**
     * Returns whether the track has any protection.
     *
     * @return True if the track has an associated protection, false
     * otherwise.
     */
    isProtected() {
        return !!this._protection && !!this._psshBox;
    }
    setLogData(logData) {
        this._logData = logData;
        return this;
    }
    /**
     * Returns a json-serializable object representing the logData for this track.
     *
     * @return The LogData.
     */
    toLogJSON() {
        return {
            uri: this._uri,
            fileId: this._fileId,
            format: this._format || '',
            resolved_url: this._resolvedURL,
        };
    }
}
//# sourceMappingURL=content.js.map